<template>
  <Modal
    ref="modal"
    :title="selectedTemplate.name"
    action="Save"
    action-color="indigo"
    @close-modal="handleCancelSettings"
    @handle-action="createSmsTemplate"
  >
    <TextInput
      label="Template Name"
      placeholder="Enter a name for this Sms template"
      :model-value="sms.templateName"
      @update:model-value="sms.templateName = $event"
    />
    <TextareaMergeTagInput
      ref="contentInput"
      label="Content"
      placeholder="Greetings from earth!"
      :model-value="sms.body"
      @update:model-value="val => (sms.body = val)"
    />
    <MergeTagSelect class="mt-4" @selected-tag="tag => $refs.contentInput.insertMergeTagAtCursor(tag)" />
  </Modal>
</template>

<script>
import Modal from '../../shared/Modal.vue';
import { toast } from 'vue-sonner';
import { useLoadingSpinnerStore } from '@/stores/loadingSpinner.ts';
import MergeTagSelect from '@/components/shared/merge_tag/MergeTagSelect/index.vue';
import TextareaMergeTagInput from '@/components/shared/merge_tag/textarea_input/TextareaMergeTagInput.vue';

export default {
  components: {
    Modal,
    MergeTagSelect,
    TextareaMergeTagInput,
  },
  props: ['selectedTemplate'],
  setup() {
    const loadingSpinnerStore = useLoadingSpinnerStore();
    return { loadingSpinnerStore };
  },
  data() {
    return {
      sms: {
        templateId: this.selectedTemplate.id,
        templateName: this.selectedTemplate.name,
        body: this.selectedTemplate.body, // used exclusively to show save template button
      },
    };
  },
  methods: {
    handleCancelSettings() {
      this.$emit('handleCancelSettings');
    },
    createSmsTemplate() {
      const self = this;
      this.loadingSpinnerStore.showLocalLoadingSpinner();
      fetch(`/api/sms_templates/`, {
        method: 'POST',
        body: JSON.stringify({
          id: self.sms.templateId,
          name: self.sms.templateName,
          body: self.sms.body,
        }),
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
        },
      })
        .then(response => response.json())
        .then(data => {
          this.loadingSpinnerStore.hideLocalLoadingSpinner();
          if (data.status != 'error') {
            toast.success('SMS template saved', {
              action: { label: 'Dismiss' },
              description: 'Your SMS Template was successfully saved.  Use the button below to dismiss this alert.',
            });
            self.$emit('handleSaveSettings');
          } else {
            toast.error('SMS template save error', {
              action: { label: 'Dismiss' },
              description: data.message,
            });
          }
        });
    },
  },
};
</script>
